import { render, staticRenderFns } from "./StartupZonePage.vue?vue&type=template&id=b436c360&scoped=true"
import script from "./StartupZonePage.vue?vue&type=script&lang=js"
export * from "./StartupZonePage.vue?vue&type=script&lang=js"
import style0 from "./StartupZonePage.vue?vue&type=style&index=0&id=b436c360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b436c360",
  null
  
)

export default component.exports